<div class="leasingModal firstClickBudgetModal">
	<div class="closeContainer">
        <mat-icon (click)="cancel()">close</mat-icon>
	</div>
	<h1>Huom!</h1>
	<div mat-dialog-content>
		<p>
	       <span *ngIf="customerNames.length == 1">{{customerNames}} ei ota vaihtoautoja vastaan. Jos kuitenkin haluat antaa autosi vaihdossa, {{customerNames}} tarjoama auto jää kilpailutuksesta pois.
	       </span>
           <span *ngIf="customerNames.length > 1">Palveluntarjoajat {{customerNames.join(', ')}} eivät ota vaihtoautoja vastaan. Jos kuitenkin haluat antaa autosi vaihdossa, {{customerNames.join(', ')}} tarjoamat autot jäävät kilpailutuksesta pois.</span>
			
		</p>
	</div>
	<div mat-dialog-actions align="end">
		<button class="orange button" (click)="ok()">Ok</button>
	</div>
</div>